import { useEffect, useRef } from "react";

// Textarea that auto-grows with its content (up to maxHeight) and stays manually resizable.
export function AutoTextarea({ value, onChange, className = "", minRows = 4, maxHeight = 420, ...props }) {
  const ref = useRef(null);

  const resize = () => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${Math.min(el.scrollHeight, maxHeight)}px`;
  };

  useEffect(() => {
    resize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <textarea
      ref={ref}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      onInput={resize}
      rows={minRows}
      style={{ maxHeight }}
      className={`resize-y overflow-auto ${className}`}
      {...props}
    />
  );
}
